import "../../../assets/RideGrid.css";
import s from "clsx";
import a from "react";
const o = "_flexible_aled1_32", e = {
  "ride-grid": "_ride-grid_aled1_1",
  flexible: o
};
function m({
  className: i,
  flexible: t,
  children: r,
  "data-testid": d
}) {
  const l = () => s(i, e["ride-grid"], {
    [e.flexible]: t
  });
  return /* @__PURE__ */ a.createElement("div", { "data-testid": d, className: l() }, r);
}
export {
  m as RideGrid
};
